<template>
    <v-app
        style="background-color: #08844E">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            striped
            color="blue"
            rounded
            height="6"
        ></v-progress-linear>
        
        <div 
            style="padding: 50px">
            <v-flex
            xs12 sm12 md12 lg12 xl12>
            <v-row>
                <v-col>
                    <v-card>
                    <v-card-text>
                        <v-row>
                            <v-card-title>
                                <h1 class="name">{{sido_sgg_title}}</h1>
                            </v-card-title>
                        <v-card-text>
                            <v-img 
                            style="border-radius: 10px;"
                            :src="cityDetails.image_src"
                            class="white--text align-end"
                            height="500">
                        </v-img>
                        </v-card-text>
                        <v-card-text>
                            <h2 class="description">
                            {{cityDetails.description}}
                        </h2>
                        </v-card-text>
                        <v-divider class="mx-4"></v-divider>
                        

                        <v-card-title class="population">
                            <h2>인구수 : &nbsp; </h2> 
                            <h2>
                            {{population}}
                        </h2>
                        <h2>(명) </h2> 
                        </v-card-title>

                        <v-card-text>
                            <h2 class="link">
                            <a :href="cityDetails.tourism_link"
                                target='_blank'
                                style="color: #FFBE59; font-size: 15px"
                            >
                            {{cityDetails.tourism_link}}
                            </a>
                        </h2>
                        </v-card-text>     
                    </v-row> 
                    
                    <v-row
                        class="places">
                        <div  
                        v-for="(place, index) in places"
                        :key="index"
                        style="padding:8px;">

                        <v-sheet
                            v-if="place.length != 0"
                            elevation="10"
                            rounded="xl"
                            >
                            <v-sheet
                            v-if="place.length != 0"
                            class="pa-3 orange text-center"
                            dark
                            rounded="t-xl"
                            >
                            {{index}}
                            </v-sheet>

                            <div class="pa-4">
                                <v-chip-group
                                active-class="primary--text"
                                column
                                v-if="place.length != 0"
                                show-arrows
                                multiple
                                >
                                
                                <v-chip
                                    v-for="item in place"
                                    :key="item.name"
                                    :href="item.link"
                                    target="_blank"
                                >
                                    {{item.name}}
                                </v-chip>
                            </v-chip-group>
                            </div>
                        </v-sheet>       
                        </div>  
                    </v-row> 
                    </v-card-text>

                    </v-card>  
                    <div style="padding: 50px">
                      <v-btn
                        fab
                        x-large
                        class="white--text"
                        color="teal"
                        @click="addPost"
                        >
                        Post
                        </v-btn>


                    </div>
                </v-col>
           
                <v-col>     
                     <div class="map" id="map" style="border-radius: 10px; height:1000px;" ></div>
                    <v-card>
                        <!-- <v-card-text><div v-for="user in AllUser" :key="user.id">{{user.nickname}}   
                            </div></v-card-text> -->
                    <v-row dense>
                    <v-col
                    v-for="user in AllUser"
                    :key="user.id"
                    >
                    <v-card @click="ShowPost">
                        <v-list-item three-line>
                <v-list-item-content>
                    <div class="text-overline mb-4">
                    <v-avatar
                        color="brown"
                        size="30"
                        >
                        <v-icon>mdi-account</v-icon>
                        </v-avatar>{{user.nickname}}
                    </div>
                    <v-list-item-title class="text-h5 mb-1">
                    {{user.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{user.address}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar
                    tile
                    size="80"
                    color="grey"
                ></v-list-item-avatar>
                </v-list-item>

                        <v-card-actions>
                        <v-spacer></v-spacer>

                
                            <v-icon>mdi-heart</v-icon>{{user.id}}
                    

                    
                        </v-card-actions>
                    </v-card>
                    </v-col>
                     </v-row>
                    </v-card> 
                   
                </v-col>
            </v-row>
        </v-flex>
        </div>
       
    </v-app>
</template>

<script>
import axios from 'axios'
import {BASE_URL} from '@/api.js'
export default {
    mounted(){
        this.getCityDetail()

        this.getPlace()

        //this.getUser()
    },
    data(){
        return{
            loading: false,
            sido_sgg : this.$route.query.name,
            cityDetails: '',
            latitude:'',
            longitude:'',
            model: null,
            beaches:'',
            mountains:'',
            rivers:'',
            valleys:'',
            places:'',
            sido_unify : { "경기": "경기도", "강원": "강원도", "충북": "충청북도", 
                      "충남": "충청남도", "경북": "경상북도", "경남": "경상남도", 
                      "전북": "전라북도", "전남": "전라남도", 
                      "제주특별자치도": "제주도", "제주": "제주도"},
            sido_sgg_title:'',
            population:'',
            AllUser:[{id: 261, nickname: '윤소림', name: '부산 맛집 코스', address: '부산 수영구 민락로33번길 17'},
            {id: 200, nickname: '우승연', name: '부산 놀거리 코스', address: '부산 해운대구 해운대로383번길 23'},
            {id: 146, nickname: '박장우', name: '부산 1박 2일 여행 코스', address: '부산 해운대구 달맞이길65번길 167'}
            ,{id: 89, nickname: '최서연', name: '부산 유명 빵집 코스', address: '부산 해운대구 청사포로 116 청사포정거장'},
            {id: 13, nickname: '윤지호', name: '부산 한달 여행 코스', address: '부산 동구 중앙대로 533번길 4'}],
            overlay: true,
             workExperiences: [
      {
        Name: "Foxconn",
        Address: "Engineer",
        image: null,
        url:null
      }
    ],
    url: null,
      image: null,
        }
    },
    methods:{
        async getCityDetail(){
            this.loading = true
            try{
            const Details = await axios.post(
                `${BASE_URL}/city/findOne`,
                {
                    sido_sgg :this.sido_sgg
                })
                console.log("cityDetails ",Details)
                this.population = this.comma(Details.data.population)
                this.cityDetails = Details.data
                this.latitude = Details.data.latitude
                this.longitude = Details.data.longitude
                
                this.sido_sgg_title = this.checkIsSpecialCity(this.sido_sgg)

                
                console.log('population : ', this.population)
                
                //지도 표시해주기
                window.kakao && window.kakao.maps ? this.initMap() : this.addScript();
                
            }catch(err){
                console.log(err)
            }
            this.loading = false
        },
        async getPlace(){
            try{
            const place = await axios.post(
                `${BASE_URL}/place/findBySidoSggAndTheme`,
                {
                    sido_sgg :this.sido_sgg
                })
                console.log("palces ",place.data)
                console.log("palces ",Object.keys(place.data))
                this.places = place.data
                
                this.beaches = place.data.beaches
                this.mountains = place.data.mountains
                this.rivers = place.data.rivers
                this.valleys = place.data.valleys
                
            }catch(err){
                console.log(err)
            }
        },
        checkIsSpecialCity(sido_sgg){
            //결과값중 특별시가 있는경우는 서울 서울 -> 서울 로 바꿔줌
            var sido = this.split_sido_sgg(sido_sgg)['sido']

            if (this.checkSpecialCity(sido)) {
                // not special city
                return sido_sgg
            } else {
                //특별시
                return sido
            }   
        },
        split_sido_sgg(sido_sgg) {
            var sido_sgg_split = sido_sgg.split(' ')
            return {"sido": sido_sgg_split[0], "sgg":sido_sgg_split[1]}
        },
        checkSpecialCity(sido) {
            if (Object.values(this.sido_unify).includes(sido)) {
                return true
            } else {
                return false
            }
        },
        async initMap() { 
            var container = document.getElementById('map'); 
            var options = { center: new kakao.maps.LatLng(this.latitude, this.longitude), level: 10 };
            var map = new kakao.maps.Map(container, options); 
            //마커추가하려면 객체를 아래와 같이 하나 만든다. 
            var marker = new kakao.maps.Marker({ position: map.getCenter() }); 
            await marker.setMap(map); 
        },  
        addScript() { 
            const script = document.createElement('script'); 
            /* global kakao */ 
            script.onload = () => kakao.maps.load(this.initMap); 
            script.src = 'http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=0b3e12f49e69284bc5e44c27065a9f7b'; 
            document.head.appendChild(script); 
        },
        comma(val){
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        async getUser(){
            try{
            const AllUser = await axios.get(
                `${BASE_URL}/user/findAll`)
                console.log('Alluser', AllUser.data)
                this.AllUser = AllUser.data
                
            }catch(err){
                console.log(err)
            }
        },
        ShowPost(){
            this.$router.push({path:'/showpost'})
        },
        addExperience () {
      this.workExperiences.push({
        company: '',
        title: ''
      })
    },
    addPost(){
        this.$router.push({path:'/addform'})
        
    },
    submit () {
      const data = {
        workExperiences: this.workExperiences
      }
      alert(JSON.stringify(data, null, 2))
    },
    Preview_image(i) {
      this.workExperiences[i].url= URL.createObjectURL(this.workExperiences[i].image)
    }
  
    }
}
</script>

<style scoped>

.name {
    font-family: "GmarketSansLight";
    text-align: center; 
}
.description {
    font-size: 15px;
    font-family: "GmarketSansMedium";
    letter-spacing: 2px;
}
.population {
    text-align: center; 
    font-family: "GmarketSansLight";
}
.link{
    border-radius: 10px;
    background-color: #42AC5E;
    font-family: "GmarketSansLight";
    text-align: center; 
}
.places{
    font-family: "GmarketSansBold";
}


</style>